import { render, staticRenderFns } from "./Vid.vue?vue&type=template&id=07e469a8&scoped=true"
import script from "./Vid.vue?vue&type=script&lang=js"
export * from "./Vid.vue?vue&type=script&lang=js"
import style0 from "./Vid.vue?vue&type=style&index=0&id=07e469a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e469a8",
  null
  
)

export default component.exports